module.exports = __webpack_public_path__ + "fonts/3768D4_1_0.26f85bd.ttf";